import axios from 'axios';

async function getFeature() {
    try {
        const fetchUrl = `/manage/feature`;
        return axios.get(fetchUrl,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then((data) => { 
                
                
                return data.data;})
    } catch (error) {
        throw new Error('Error loading features');
    }
}

export default getFeature;
